import {inject, injectable} from 'inversify';

import type {Expand} from '../../../../api/types';

import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class FollowerExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {};
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace FollowerExpandJrpc {
  export type ExpandedFields = unknown;
}
